import './styles/PushNotificationCard.scss';

import { Alert, Grid, Paper, Switch, Typography } from '@mui/material';

import { useFormikContext } from 'formik';
import { MailX } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

export const MailSendDisabledCard = () => {
  const { t } = useTranslation();

  const { values, setFieldValue } = useFormikContext<{
    isSendMailDisabled: boolean;
    id: string | number;
  }>();
  return (
    <>
      <Grid container elevation={2} className="pushNotificationCard" component={Paper} square>
        <Grid item xs={4}>
          <Grid container gap={2}>
            <Grid item md={2}>
              <MailX size={55} />
            </Grid>
            <Grid item md={2} className="pushToggleContainer">
              <Switch
                name="isSendMailDisabled"
                className="pushToggle"
                disabled={!!values.id}
                checked={values.isSendMailDisabled}
                onChange={v => {
                  setFieldValue('isSendMailDisabled', v.target.checked);
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={8}>
          <Grid container className="" gap={2}>
            <Typography variant="subtitle2">
              {t(translations.pages.articles.create.preview.mailNotSend())}
            </Typography>
            <Alert severity="info">
              {t(translations.pages.articles.create.preview.mailNotSendAlert())}
            </Alert>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
